import { getVideoElAudioTrack, getVideoElVideoTrack } from './../helpers/media';
import { getSelfPublisherErrors } from './call';
import * as core from './../../core';
import * as devices from './../../devices';
import { createSelector } from 'reselect';
import { get } from 'lodash';
export const getActivePublisher = () => {
    const VideoProviderFactory = core.getAngularService(core.AngularServices.VideoProviderFactory);
    const activeProvider = VideoProviderFactory.activeProvider;
    return activeProvider ? activeProvider.getPublisher() : null;
};
export const getPublisherVideoEl = () => {
    const publisher = getActivePublisher();
    return publisher ? publisher.videoElement() : null;
};
export const hasVideo = createSelector(getPublisherVideoEl, (videoEl) => {
    if (!videoEl)
        return false;
    const track = getVideoElVideoTrack(videoEl);
    return !!track && track.enabled;
});
export const hasAudio = createSelector(getPublisherVideoEl, (videoEl) => {
    if (!videoEl)
        return false;
    const track = getVideoElAudioTrack(videoEl);
    return !!track && track.enabled;
});
export const isPublisherLoading = () => {
    const VideoProviderFactory = core.getAngularService(core.AngularServices.VideoProviderFactory);
    const activeProvider = VideoProviderFactory.activeProvider;
    return !!activeProvider.isPublisherLoading;
};
export const getLocalMediaState = createSelector(devices.selectors.hasCameraAccess, devices.selectors.hasMicrophoneAccess, devices.selectors.getCurrentCamera, devices.selectors.getCurrentMicrophone, devices.selectors.getCurrentSpeaker, devices.selectors.getCameras, devices.selectors.getMicrophones, devices.selectors.getSpeakers, hasAudio, hasVideo, getSelfPublisherErrors, isPublisherLoading, (hasCameraAccess, hasMicrophoneAccess, currentCamera, currentMic, currentSpeaker, cameras, mics, speakers, hasAudio, hasVideo, selfPublisherErrors, isPublisherLoading) => {
    return {
        hasCameraAccess,
        hasMicrophoneAccess,
        hasVideo,
        hasAudio,
        isPublisherLoading,
        mediaErrors: selfPublisherErrors.map((e) => `${e.type}${e.message ? ':' + e.message : ''}`),
        cameras: cameras.map((device) => device.label),
        mics: mics.map((device) => device.label),
        speakers: speakers.map((device) => device.label),
        currentCamera: get(currentCamera, 'label', null),
        currentMic: get(currentMic, 'label', null),
        currentSpeaker: get(currentSpeaker, 'label', null),
    };
});
